import React from "react";
import RV from "simple-react-validator";
import ls from "local-storage";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import * as CONFIG from "./_config";

toast.configure();
const axios = require("axios");

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {},
      stores: [],
      MemberCardMaxLength: 12,
      MemberCardMinLength: 12,
      isvalidcard: false,
    };
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  Stores() {
    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    if (ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");
      var apiurl;
      if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
        //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`);
      } else {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
        //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`);
      }
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          // console.log('res',res);
          ls.set("ClientStores", res.data.GetClientStores);
          this.setState({ stores: res.data.GetClientStores });
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  componentDidMount() {
    if (ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`))
      window.location.href = "/";

    this.Stores();
    this.CardInfo();

    if (!CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION) {
      this.props.history.push("/simple-register");
    }
  }

  CardInfo = async (e) => {
    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCompanySettingsAndContactInfoByStoreGroup`;
    const data = new FormData();
    data.append("method", "POST");
    //data.append('apiurl', 'https://grocery.rsaamerica.com/Services/SSWebRestApi.svc/GetCompanySettingsAndContactInfoByStoreGroup');
    data.append("ClientAppName", CONFIG.DATA.RSA_CLIENT_APP_NAME);
    data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
    data.append("StoreGroupId", CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID);
    data.append("StoreId", CONFIG.DATA.RSA_CLIENT_STORE_ID);

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })

      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode === 1) {
          this.setState({
            MemberCardMaxLength: res.data.CompanySettings.MemberCardMaxLength,
          });
          this.setState({
            MemberCardMinLength: res.data.CompanySettings.MemberCardMinLength,
          });
        }
      })
      .catch(function (ress) {
        console.log(ress);
        toast.error("Error Notification !");
      });
  };

  cardvalidate = (e) => {
    const carddata = [
      this.state.MemberCardMaxLength,
      this.state.MemberCardMinLength,
    ];
    // console.log(carddata,'carddata');
    // console.log(this.state.formControls.MemberNumber.length,'this.state.formControls.MemberNumber.length');
    // console.log(this.state.formControls.MemberNumber === this.state.formControls.ConfirmMemberNumber,'this.state.formControls.MemberNumber === this.state.formControls.ConfirmMemberNumber');
    if (
      this.state.formControls.MemberNumber &&
      carddata.includes(this.state.formControls.MemberNumber.length) &&
      this.state.formControls.MemberNumber ===
        this.state.formControls.ConfirmMemberNumber
    ) {
      const data = new FormData();
      data.append("method", "POST");
      //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/services/SSWebRestApi.svc/ValidateMemberNumber/${this.state.formControls.MemberNumber}`);
      var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ValidateMemberNumber/${this.state.formControls.MemberNumber}`;
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          console.log(res, "res");
          if (res.data.ErrorMessage.ErrorCode)
            this.setState({ isvalidcard: true });
          else this.setState({ isvalidcard: false });
        })
        .catch(function (ress) {
          this.setState({ isvalidcard: false });
          console.log(ress);
        });
    }
  };

  Register = async (e) => {
    // console.log(this.state.formControls);
    e.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }
    if (!this.state.isvalidcard) {
      toast.error("Enter valid card detail!");
      return false;
    }

    const data = new FormData();
    data.append("method", "POST");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/services/SSWebRestApi.svc/NewRegister`);
    data.append("UserName", this.state.formControls.username);
    data.append("Password", this.state.formControls.password);
    data.append("FirstName", this.state.formControls.firstname);
    data.append("LastName", this.state.formControls.lastname);
    data.append("DeviceType", "D258B2E7-BA54-4855-B919-1CA28C9F8B57");
    data.append("DeviceId", "2");
    data.append("ZipCode", this.state.formControls.zipcode);
    data.append("CustomerId", 1);
    data.append("ClientStoreId", this.state.formControls.client_store);
    data.append("MemberNumber", this.state.formControls.MemberNumber);

    var apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/NewRegister`;
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })

      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode <= 0) {
          toast.error(res.data.ErrorMessage.ErrorDetails);
        } else {
          toast.success("Register Successfully !", { autoClose: 7000 });
          // window.location.href = "/login";
        }
      })
      .catch(function (ress) {
        console.log(ress);
        toast.error("Error Notification !");
      });
  };

  handleChange = (value) => {
    // console.log("Captcha value:", value);
    this.setState({
      formControls: { ...this.state.formControls, ["Captcha"]: value },
    });
  };

  asyncScriptOnLoad = () => {
    // this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  render() {
    return (
      <div>
        <div className="main-container full-width pt-5 mt-5  ">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Link Card Registration</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <span>Link Card Registration</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">Link Card Registration</h1>
                  </header>
                  <div className="breadcrumbs d-none d-md-block">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> Link Card Registration</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row pt-5">
            <div className="col-md-1"></div>
            <div className="col-md-6">
              <p style={{ textAlign: "left" }}>
                By creating an account with our store, you will be able to build
                shopping list, access digital coupons and browse through weekly
                flyer.
              </p>
              <div>
                <div className="row">
                  <div
                    className={
                      (CONFIG.DATA.LINK_CARD_MOBILE_IMAGE != ""
                        ? "col-md-6"
                        : "col-md-12") + " "
                    }
                  >
                    <div className="register-car">
                      <h3>Register your Loyalty card online</h3>
                    </div>
                    <div className="text-center">
                      <img
                        alt="Membership Barcode"
                        src="/assets/images/barcode.png"
                      />
                    </div>
                  </div>
                  {CONFIG.DATA.LINK_CARD_MOBILE_IMAGE != "" ? (
                    <div className="col-md-6">
                      <div className="register-car">
                        <h3>Register on Mobile App</h3>
                      </div>
                      <div className="text-center">
                        <img
                          alt="Mobile App"
                          src={CONFIG.DATA.LINK_CARD_MOBILE_IMAGE}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-11 {/*offset-1*/} ">
                    <div className="regiter text-left pt-5">
                      <p>
                        1. Register card by typing all in your full member card
                        number.
                      </p>
                      <p>
                        2. Register your card by scanning with your mobile app!
                      </p>
                      <p>
                        3. Link digital offers, use punch cards, and earn points
                        on every visit with your REGISTERED rewards card!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-5">
              <div className="">
                <h3>Register</h3>
              </div>
              <div className="page-content border pt-3">
                <div className="container">
                  <article
                    id="post-22"
                    className="post-22 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="at-above-post-page addthis_tool"></div>
                      <div className="woocommerce">
                        <div className="woocommerce-notices-wrapper"></div>

                        <form method="post" className="login">
                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="username">
                              LOYALTY Card#<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="input-text form-control"
                              name="MemberNumber"
                              id="MemberNumber"
                              onChange={(e) => this.changeHandler(e)}
                              onKeyUp={(e) => this.cardvalidate(e)}
                              onBlur={() =>
                                this.validator.showMessageFor("Member_Number")
                              }
                              maxLength={this.state.MemberCardMaxLength}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "Member_Number",
                                this.state.formControls.MemberNumber,
                                "required|max:" +
                                  this.state.MemberCardMaxLength +
                                  "|min:" +
                                  this.state.MemberCardMinLength
                              )}
                            </span>
                          </div>

                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="username">
                              Confirm Card# &nbsp;
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="input-text form-control"
                              name="ConfirmMemberNumber"
                              id="ConfirmMemberNumber"
                              onChange={(e) => this.changeHandler(e)}
                              onKeyUp={(e) => this.cardvalidate(e)}
                              onBlur={() =>
                                this.validator.showMessageFor(
                                  "ConfirmMemberNumber"
                                )
                              }
                              maxLength={this.state.MemberCardMaxLength}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "ConfirmMemberNumber",
                                this.state.formControls.ConfirmMemberNumber,
                                `required|in:${this.state.formControls.MemberNumber}|max:${this.state.MemberCardMaxLength}|min:${this.state.MemberCardMinLength}|in:${this.state.formControls.MemberNumber}`,
                                {
                                  messages: {
                                    in: "Member Number need to match!",
                                  },
                                }
                              )}
                            </span>
                          </div>

                          {/*<p className="form-group form-row form-row-wide">
                                                        <label htmlFor="username">First Name <span
                                                            className="required">*</span></label>
                                                        <input type="text" className="input-text form-control"
                                                               name="ConfirmMemberNumber" id="ConfirmMemberNumber"
                                                               onChange={(e) => this.changeHandler(e)}/>
                                                        <span
                                                            className='text-danger'>{this.validator.message('username', this.state.formControls.firstname, 'required|alpha')}</span>
                                                    </p>*/}

                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="username">
                              First Name <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="input-text form-control"
                              name="firstname"
                              id="firstname"
                              onChange={(e) => this.changeHandler(e)}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "first_name",
                                this.state.formControls.firstname,
                                "required|alpha"
                              )}
                            </span>
                          </div>
                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="password">
                              Last Name <span className="required">*</span>
                            </label>
                            <input
                              className="input-text form-control"
                              type="text"
                              name="lastname"
                              id="lastname"
                              onChange={(e) => this.changeHandler(e)}
                            />

                            <span className="text-danger">
                              {this.validator.message(
                                "last_name",
                                this.state.formControls.lastname,
                                "required|alpha"
                              )}
                            </span>
                          </div>
                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="password">
                              Zip Code <span className="required">*</span>
                            </label>
                            <input
                              className="input-text form-control"
                              type="text"
                              maxLength="5"
                              name="zipcode"
                              id="zipcode"
                              onChange={(e) => this.changeHandler(e)}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "zip_code",
                                this.state.formControls.zipcode,
                                "required"
                              )}
                            </span>
                          </div>
                          <div>
                            <div className="form-group form-row form-row-wide">
                              <label htmlFor="password">
                                Preferred Store{" "}
                                <span className="required">*</span>
                              </label>
                              <select
                                name="client_store"
                                className="form-control"
                                id="client_store"
                                onChange={(e) => this.changeHandler(e)}
                              >
                                <option value="">Select</option>
                                {this.state.stores.map((value, index) => (
                                  <option
                                    key={index}
                                    value={value.ClientStoreId}
                                  >
                                    {value.ClientStoreName}
                                  </option>
                                ))}
                              </select>
                              <span className="text-danger display-block float-left">
                                {this.validator.message(
                                  "Preferred Store",
                                  this.state.formControls.client_store,
                                  "required"
                                )}
                              </span>
                            </div>
                          </div>

                          <div className="form-group form-row form-row-wide">
                            <label htmlFor="password">
                              Email Address <span className="required">*</span>
                            </label>
                            <input
                              className="input-text form-control"
                              type="email"
                              name="username"
                              id="username"
                              onChange={(e) => this.changeHandler(e)}
                            />
                            <span className="text-danger">
                              {this.validator.message(
                                "Email Address",
                                this.state.formControls.username,
                                "required|email"
                              )}
                            </span>
                          </div>
                          {CONFIG.DATA.ALLOW_PASSWORD ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesfoodking" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessupersave" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "market33" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "fiestafoodsamarillo" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "topvaluecostplus" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "pandlcountrymarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN ===
                            "bradfordgeneralstore" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lagreesfoodstores" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "mcdanielpw" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "kirbyfoods" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "vowellsmarketplace" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw" ? (
                            <>
                              <div className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  Password <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  maxLength="12"
                                  minLength="6"
                                  name="password"
                                  id="password"
                                  onChange={(e) => this.changeHandler(e)}
                                  autoComplete="nope"
                                />
                                <span className="text-danger float-left">
                                  {this.validator.message(
                                    "password",
                                    this.state.formControls.password,
                                    "required"
                                  )}
                                </span>
                              </div>
                              <div className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  Re-enter Password{" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  minLength={6}
                                  pattern="/^(?=^.{6,}$)^[a-zA-Z0-9_@./#&+-]*$/"
                                  maxLength="12"
                                  name="repassword"
                                  id="repassword"
                                  onChange={(e) => this.changeHandler(e)}
                                />
                                <span className="text-danger">
                                  {this.validator.message(
                                    "re-password",
                                    this.state.formControls.repassword,
                                    `required|in:${this.state.formControls.password}`,
                                    {
                                      messages: {
                                        in: "Passwords need to match!",
                                      },
                                    }
                                  )}
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  PIN <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  maxLength="4"
                                  name="password"
                                  id="password"
                                  onChange={(e) => this.changeHandler(e)}
                                />
                                <span className="text-danger float-left">
                                  {this.validator.message(
                                    "pin",
                                    this.state.formControls.password,
                                    "required"
                                  )}
                                </span>
                              </div>
                              <div className="form-group form-row form-row-wide">
                                <label htmlFor="password">
                                  Re-enter PIN{" "}
                                  <span className="required">*</span>
                                </label>
                                <input
                                  className="input-text form-control"
                                  type="password"
                                  maxLength="4"
                                  name="repassword"
                                  id="repassword"
                                  onChange={(e) => this.changeHandler(e)}
                                />
                                <span className="text-danger">
                                  {this.validator.message(
                                    "re-pin",
                                    this.state.formControls.repassword,
                                    `required|in:${this.state.formControls.password}`,
                                    {
                                      messages: {
                                        in: "PINs need to match!",
                                      },
                                    }
                                  )}
                                </span>
                              </div>
                            </>
                          )}

                          <div
                            className="wpforms-submit-container mb-2 employmentcheckbox float-left "
                            style={{ color: "#999999" }}
                          >
                            <p style={{ textAlign: "left" }}>
                              <input
                                type="checkbox"
                                onChange={(e) => this.changeHandler(e)}
                                value="1"
                                name="terms"
                                className="wpforms-field-medium "
                              />{" "}
                              I agree to the {CONFIG.DATA.RSA_CLIENT_APP_NAME}{" "}
                              <Link to="/company-policies">
                                Terms and Conditions
                              </Link>
                            </p>
                            <div className="text-danger text-left ">
                              {this.validator.message(
                                "Terms and Conditions ",
                                this.state.formControls.terms,
                                "required"
                              )}
                            </div>
                          </div>

                          <div className="ReCAPTCHA">
                            <ReCAPTCHA
                              style={{ display: "block" }}
                              theme="light"
                              sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                              onChange={this.handleChange}
                              asyncScriptOnLoad={this.asyncScriptOnLoad}
                            />

                            <p className="text-danger text-center">
                              {this.validator.message(
                                "captcha",
                                this.state.formControls.Captcha,
                                "required"
                              )}
                            </p>
                            <br />
                          </div>

                          <div className="form-group form-row">
                            <div className="form-group clearfix"></div>
                            <input
                              type="button"
                              id="register_button"
                              className="woocommerce-Button button btn btn-theme btn-block"
                              name="login"
                              value="Register"
                              onClick={(e) => this.Register(e)}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;
